
import { Vue, Component, Prop } from "vue-property-decorator";
// Entities
import { Company, Profile } from "@/entities/index";
// Services
import { getPiecesAndReferences } from "@/services";

@Component
export default class Chart2 extends Vue {
  @Prop() readonly warehouseCode!: string;
  client = this.company.codeLogistic || this.profile.company.codeLogistic;
  integrateStepZero = this.company.integrateStepZero;

  piecesAndReferences: unknown[] = [];
  reasons: string[] = [];

  get optionsPiecesAndReferences(): unknown {
    return {
      xaxis: {
        categories: this.reasons,
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
      colors: ["#154077", "#aabb00"],
    };
  }

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  async loadPiecesAndReferences(): Promise<void> {
    const { reasons, pieces, references } = await getPiecesAndReferences({
      client: this.client,
      warehouse: this.warehouseCode,
      integrateStepZero: this.integrateStepZero,
    });
    this.piecesAndReferences = [
      {
        name: this.$t("dataDashboard.charts.chart2.pieces"),
        data: pieces,
      },
      {
        name: this.$t("dataDashboard.charts.chart2.references"),
        data: references,
      },
    ];
    this.reasons = reasons;
  }
}
